import { render, staticRenderFns } from "./FeedBackList.vue?vue&type=template&id=2cf5239a&scoped=true&"
import script from "./FeedBackList.vue?vue&type=script&lang=js&"
export * from "./FeedBackList.vue?vue&type=script&lang=js&"
import style0 from "./FeedBackList.vue?vue&type=style&index=0&id=2cf5239a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5239a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cf5239a')) {
      api.createRecord('2cf5239a', component.options)
    } else {
      api.reload('2cf5239a', component.options)
    }
    module.hot.accept("./FeedBackList.vue?vue&type=template&id=2cf5239a&scoped=true&", function () {
      api.rerender('2cf5239a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/report/FeedBackList.vue"
export default component.exports